<script setup lang="ts">
const article = inject(keys.currentArticle)
</script>

<template>
  <div
    v-if="article?.contentType === 'article'"
    class="article relative article-body text-green-50"
    :class="article?.colorTheme"
  >
    <div class="article__paragraphs flex flex-col gap-4">
      <UiArticlesText
        v-for="(paragraph) in article?.body"
        :key="paragraph"
        :paragraph="paragraph"
      />
      <section v-if="article?.inlineCtas?.length" class="my-8 flex flex-wrap justify-center gap-8">
        <CtaForArticles :content="article.inlineCtas" />
      </section>
      <UiArticlesText
        v-for="paragraph in article?.postCtaBody"
        :key="paragraph"
        :paragraph="paragraph"
      />
      <div
        v-if="article?.extraBox && article.extraBox !== '<p></p>'"
        class="my-4 bg-(--foreground) px-8 py-6 text-(--background) md:px-14 md:py-8 [&_a]:!whitespace-normal"
        v-html="article.extraBox"
      />
      <template v-if="article?.footnotes && article.footnotes !== '<p></p>'">
        <hr />
        <div class="mx-0 my-8 text-sm leading-5" v-html="article.footnotes" />
        <hr />
      </template>
      <UiArticlesAccordion />
    </div>
  </div>
</template>

<style scoped>
@reference "~/assets/styles/main.css";

.article {
  h2,
  h3,
  h4,
  h5 {
    margin: 1.4rem 0 1rem 0;
  }
}

.article__paragraphs {
  :deep(p) {
    margin-bottom: 0.8rem;
  }

  :deep(a) {
    @apply text-ellipsis overflow-hidden whitespace-nowrap inline-block max-w-[90vw] align-bottom;
  }

  h2,
  h3,
  h4 {
    margin-block: 1rem;
  }

  div p h4,
  div p h5 {
    margin: 2rem 0 1rem 0;
  }

  ul {
    li {
      padding: 0.4rem 0;
      margin-left: 1.4rem;

      @media screen and (min-width: theme('screens.md')) {
        margin: 0;
      }
    }
  }
}
</style>
